<div class="container">
  <div class="row">
    <div class="col-60 spacer-info">
      <div [innerHTML]="staticHtml | safeHtml" *ngIf="staticHtml"></div>
    </div>
  </div>
</div>
<div class="padding-go-up-button"></div>
